module.exports = __webpack_public_path__ + "img/img5.0168b7a1.png";